import StackedColumn from '../../../../../../utility/generateHighChart/columnChart/StackedColumn.abstract';

class DiversityOverTime extends StackedColumn {
  isStacked = true;
}

export default DiversityOverTime;
